import createOpenApiClient, { Client } from 'openapi-fetch';
import { AuthMiddlewareHooks, makeAuthMiddleware } from './AuthMiddleware';
import {
  ClientIdMiddlewareHooks,
  makeClientIdMiddleware,
} from './ClientIdMiddleware';
import type { paths } from './generated/types';

export interface ApiClientConfig {
  baseUrl: string;
  authToken?: string;
  clientId?: string;
}

export type ClipsClient = Client<paths> &
  AuthMiddlewareHooks &
  ClientIdMiddlewareHooks;

/**
 * The API client for making API calls. In addition:
 * - it holds auth state
 * - it automatically sets the auth token after a successful call to /authenticate
 */
export function createClient(config: ApiClientConfig): ClipsClient {
  const client = createOpenApiClient<paths>({ baseUrl: config.baseUrl });

  const { middleware: authMiddleware, ...authHooks } = makeAuthMiddleware(
    config.authToken,
  );

  const { middleware: clientIdMiddleware, ...clientIdHooks } =
    makeClientIdMiddleware(config.clientId);
  client.use(authMiddleware);
  client.use(clientIdMiddleware);

  return { ...client, ...authHooks, ...clientIdHooks };
}
